const initLocationTabs = (root) => {
  const buttons = Array.from(root.querySelectorAll('.location-tabs__trigger'));
  const panels = Array.from(root.querySelectorAll('.location-tabs__panel'));

  if (!buttons.length || !panels.length) {
    return;
  }

  const setActive = (id) => {
    buttons.forEach((button) => {
      const isActive = button.dataset.tabTarget === id;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-selected', isActive ? 'true' : 'false');
      // Every tile remains reachable with Tab; arrows provide faster tab navigation.
      button.setAttribute('tabindex', '0');
    });

    panels.forEach((panel) => {
      const isActive = panel.dataset.tabId === id;
      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;
    });
  };

  const scrollToPanelOnMobile = (id) => {
    if (!window.matchMedia('(max-width: 767px)').matches) {
      return;
    }

    const panel = panels.find((item) => item.dataset.tabId === id);

    if (panel) {
      requestAnimationFrame(() => {
        panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  };

  const firstId = buttons[0]?.dataset.tabTarget;

  if (firstId) {
    setActive(firstId);
  }

  root.setAttribute('data-tabs-initialized', 'true');

  buttons.forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      setActive(button.dataset.tabTarget);
      scrollToPanelOnMobile(button.dataset.tabTarget);
    });

    button.addEventListener('keydown', (event) => {
      const currentIndex = buttons.indexOf(button);
      let nextIndex = null;

      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
        nextIndex = (currentIndex + 1) % buttons.length;
      } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
        nextIndex = (currentIndex - 1 + buttons.length) % buttons.length;
      } else if (event.key === 'Home') {
        nextIndex = 0;
      } else if (event.key === 'End') {
        nextIndex = buttons.length - 1;
      }

      if (nextIndex === null) {
        return;
      }

      event.preventDefault();
      const nextButton = buttons[nextIndex];
      setActive(nextButton.dataset.tabTarget);
      nextButton.focus();
      scrollToPanelOnMobile(nextButton.dataset.tabTarget);
    });
  });
};

const initAllLocationTabs = () => {
  document.querySelectorAll('.location-tabs').forEach(initLocationTabs);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAllLocationTabs);
} else {
  initAllLocationTabs();
}
